// src/hooks/useSendRegUtm.js
import { useEffect, useRef } from 'react';
import pb from '../pocketbase';
import { getStoredRegUtm, clearStoredRegUtm } from '../utils/regUtmStorage';

/**
 * Хук: после успешного логина отправляет reg_utm_query в users record.
 * 
 * @param {string|null|undefined} userId - ID текущего пользователя
 */
export function useSendRegUtm(userId) {
    const sentRef = useRef(false);

    useEffect(() => {
        // Нет пользователя — выходим
        if (!userId) return;

        // Уже отправили в этой сессии — выходим
        if (sentRef.current) return;

        const regUtmQuery = getStoredRegUtm();

        // Нечего отправлять — выходим
        if (!regUtmQuery) return;

        // Помечаем, что начали отправку (чтобы не дублировать)
        sentRef.current = true;

        // Обновляем reg_utms в users collection
        pb.collection('users').update(userId, { reg_utms: regUtmQuery })
            .then(() => {
                console.log('[useSendRegUtm] reg_utm_query saved for user:', userId);
                // Очищаем localStorage после успешной отправки
                clearStoredRegUtm();
            })
            .catch((error) => {
                console.error('[useSendRegUtm] update error:', error);
                // При ошибке разрешаем повторную попытку при следующем рендере
                sentRef.current = false;
            });
    }, [userId]);
}
